var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeadlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91458 12.0287C2.09897 13.6737 3.43604 14.9798 5.08944 15.0594C6.23224 15.1145 7.39965 15.1431 8.66667 15.1431C9.93369 15.1431 11.1011 15.1145 12.2439 15.0594C13.8973 14.9798 15.2344 13.6737 15.4188 12.0287C15.5429 10.9209 15.6448 9.78514 15.6448 8.62818C15.6448 7.47121 15.5429 6.33546 15.4188 5.22768C15.2344 3.58267 13.8973 2.27656 12.2439 2.19693C11.1011 2.14189 9.93369 2.11328 8.66667 2.11328C7.39965 2.11328 6.23224 2.14189 5.08944 2.19693C3.43604 2.27656 2.09897 3.58267 1.91458 5.22768C1.79041 6.33546 1.68854 7.47121 1.68854 8.62818C1.68854 9.78514 1.79041 10.9209 1.91458 12.0287Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09918 0.856934L6.09918 3.75886",
    stroke: "#969696",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2264 0.856934L11.2264 3.75886",
    stroke: "#969696",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91458 12.0287C2.09897 13.6737 3.43604 14.9798 5.08944 15.0594C6.23224 15.1145 7.39965 15.1431 8.66667 15.1431C9.93369 15.1431 11.1011 15.1145 12.2439 15.0594C13.8973 14.9798 15.2344 13.6737 15.4188 12.0287C15.5429 10.9209 15.6448 9.78514 15.6448 8.62818C15.6448 7.47121 15.5429 6.33546 15.4188 5.22768C15.2344 3.58267 13.8973 2.27656 12.2439 2.19693C11.1011 2.14189 9.93369 2.11328 8.66667 2.11328C7.39965 2.11328 6.23224 2.14189 5.08944 2.19693C3.43604 2.27656 2.09897 3.58267 1.91458 5.22768C1.79041 6.33546 1.68854 7.47121 1.68854 8.62818C1.68854 9.78514 1.79041 10.9209 1.91458 12.0287Z",
    stroke: "#969696"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02243 7.11377H15.3796",
    stroke: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadlineIcon);
export default __webpack_public_path__ + "static/media/deadline-icon.04a1f7d8fdd202a316501d844c042656.svg";
export { ForwardRef as ReactComponent };